import { eventRegistry } from '../events/registry';

// TODO: do we need this router or can each individual track file listen for its own events?
export default class AnalyticsEventRouter {
  constructor() {
    window.site = window.site || {};
    window.site.track = window.site.track || {};

    window.addEventListener('cart.offerSuccess', (event: CustomEvent) => {
      this.onOffer('offerSuccessful', event);
    });
    window.addEventListener('cart.offerFail', (event: CustomEvent) => {
      this.onOffer('offerFailed', event);
    });
    window.addEventListener('cart.offerRemove', (event: CustomEvent) => {
      this.onOffer('offerRemove', event);
    });
    window.addEventListener('cart.sampleAdded', (event: CustomEvent) => {
      this.onSampleAdded(event);
    });
    window.addEventListener('cart.sampleRemoved', (event: CustomEvent) => {
      this.onSampleRemoved(event);
    });
    window.addEventListener('cart.removeFromCart', (event: CustomEvent) => {
      this.onRemoveFromCart(event);
    });
    window.addEventListener('cart.addToCart', (event: CustomEvent) => {
      this.onAddToCart(event);
    });
    window.addEventListener('openCart', (event: CustomEvent) => {
      this.onAddToCart(event);
    });
    window.addEventListener('iam.registration', (event: CustomEvent) => {
      this.onRegistration(event);
    });
    window.addEventListener('iam.registrationFailed', (event: CustomEvent) => {
      this.onRegistrationFailed(event);
    });
    window.addEventListener('iam.accountRoute', (event: CustomEvent) => {
      this.onAccountRoute(event);
    });
    window.addEventListener('iam.signIn', (event: CustomEvent) => {
      this.onSignIn(event);
    });
    window.addEventListener('iam.signInFailed', (event: CustomEvent) => {
      this.onSignInFailed(event);
    });
    window.addEventListener('nav.globalNavClick', (event: CustomEvent) => {
      this.onGlobalNavClick(event);
    });
    window.addEventListener('nav.subNavClick', (event: CustomEvent) => {
      this.onSubNavClick(event);
    });
    window.addEventListener('analytics.overlayProductClick', (event: CustomEvent) => {
      this.onOverlayProductClick(event);
    });
    window.addEventListener('analytics.productClick', (event: CustomEvent) => {
      this.onProductClick(event);
    });
    window.addEventListener('analytics.quickshop.clicked', (event: CustomEvent) => {
      this.onQuickshopClick(event);
    });
    window.addEventListener('searchOverlayDisplayedEvent', () => {
      this.onSearchOverlayDisplayed();
    });
    window.addEventListener('cart.drawer.clicked', (event: CustomEvent) => {
      this.onCartDrawer(event);
    });
    window.addEventListener('VTOActionsTracking', (event: CustomEvent) => {
      this.onVTOActionsTracking(event);
    });
    window.addEventListener('phx:trackEvent', (event: CustomEvent) => {
      // add additional cases for new event
      switch (event?.detail?.event_name) {
        case 'sortEvent':
          this.onSortClick(event);
          break;
        case 'searchPageLoadedEvent':
          this.onSearchPageLoadedEvent(event);
          break;
        case 'searchPredictedEvent':
          this.onSearchPredicted(event);
          break;
        case 'analytics.gnavPromo':
          this.onGnavPromoClick(event);
          break;
        case 'analytics.filterComplete':
          this.onFilterComplete(event);
          break;
        case 'analytics.categoryToggle':
          this.onCategoryToggle(event);
          break;
        default:
          break;
      }
    });
    window.addEventListener('altImage.clicked', (event: CustomEvent) => {
      this.onAltImageClick(event);
    });
    window.addEventListener('pdp.accordion', (event: CustomEvent) => {
      this.onPdpAccordion(event);
    });
    window.addEventListener('pdp.onReviewSubmit', (event: CustomEvent) => {
      this.onPdpReviewSubmit(event);
    });
    window.addEventListener('pdp.onReviewStart', (event: CustomEvent) => {
      this.onPdpReviewStart(event);
    });
    window.addEventListener('pdp.onReviewSort', (event: CustomEvent) => {
      this.onPdpReviewSort(event);
    });
  }

  // TODO: move this data translation to the track file on next refactor
  onSearchPageLoadedEvent(event: CustomEvent) {
    const eventName = 'searchPageLoaded';
    const searchPageLoaded = event?.detail?.payload?.value || '';
    if (searchPageLoaded) {
      eventRegistry[eventName]?.(eventName, searchPageLoaded);
    }
  }

  onSearchPredicted(event: CustomEvent) {
    const eventName = 'searchPredicted';
    const searchPredicted = event?.detail?.payload?.value || '';
    if (searchPredicted) {
      eventRegistry[eventName]?.(eventName, searchPredicted);
    }
  }

  onSearchOverlayDisplayed() {
    const eventName = 'searchOverlayDisplayed';
    eventRegistry[eventName]?.(eventName, {});
  }

  onSortClick(event: CustomEvent) {
    const eventName = 'sortClick';
    const sortOption = event?.detail?.payload?.value || '';
    if (sortOption) {
      eventRegistry[eventName]?.(eventName, {
        sort_option: sortOption
      });
    }
  }

  onVTOActionsTracking(event: CustomEvent) {
    const eventName = 'VTOActionsTracking';
    const eventData = event?.detail || {};
    eventRegistry[eventName]?.(eventName, eventData);
  }

  onProductClick(event: CustomEvent) {
    const eventName = 'productClick';
    const productId = event?.detail?.productId || '';
    if (productId) {
      eventRegistry[eventName]?.(eventName, {
        product_id: [`PROD${productId}`]
      });
    }
  }

  onOverlayProductClick(event: CustomEvent) {
    const eventName = 'productClick';
    const productId = event?.detail?.productId || '';
    if (productId) {
      eventRegistry[eventName]?.(eventName, {
        product_id: [`PROD${productId}`],
        is_overlay: true
      });
    }
  }

  onQuickshopClick(event: CustomEvent) {
    const eventName = 'quickView';
    const productId = event?.detail?.productId || '';
    if (productId) {
      eventRegistry[eventName]?.(eventName, {
        product_id: [`PROD${productId}`]
      });
    }
  }

  onNavClick(event: CustomEvent) {
    const eventName = 'navigationClick';
    const promoName = event?.detail?.event?.target?.innerText || '';
    eventRegistry[eventName]?.(eventName, {
      promo_name: promoName
    });
  }

  onGlobalNavClick(event: CustomEvent) {
    this.onNavClick(event);
  }

  onSubNavClick(event: CustomEvent) {
    this.onNavClick(event);
  }

  onRegistration(event: CustomEvent) {
    const eventName = 'registration';
    const accountReferrer = event?.detail?.provider || '';
    const accountSource = event?.detail?.source || '';
    const accountType = event?.detail?.type || '';
    const userId = event?.detail?.userId || '';
    eventRegistry[eventName]?.(eventName, {
      account_referrer: accountReferrer,
      account_source: accountSource,
      account_type: accountType,
      USER_ID: userId
    });
  }

  onRegistrationFailed(event: CustomEvent) {
    const eventName = 'registrationFailed';
    const accountReferrer = event?.detail?.provider || '';
    const accountSource = event?.detail?.source || '';
    const accountType = event?.detail?.type || '';
    eventRegistry[eventName]?.(eventName, {
      account_referrer: accountReferrer,
      account_source: accountSource,
      account_type: accountType
    });
  }

  onPdpReviewSubmit(event: CustomEvent) {
    const eventName = 'writeaReview';
    const reviewProdId = event?.detail?.prodID || '';
    if (reviewProdId) {
      eventRegistry[eventName]?.(eventName, {
        review_prodid: reviewProdId
      });
    }
  }

  onPdpReviewStart(event: CustomEvent) {
    const eventName = 'reviewStart';
    const reviewProdId = event?.detail?.prodID || '';
    if (reviewProdId) {
      eventRegistry[eventName]?.(eventName, {
        review_prodid: reviewProdId
      });
    }
  }

  onPdpReviewSort(event: CustomEvent) {
    const eventName = 'reviewSort';
    const reviewSortVal = event?.detail?.sortVal || '';
    const reviewSortProdId = event?.detail?.prodID || '';
    if (reviewSortVal) {
      eventRegistry[eventName]?.(eventName, {
        review_sort: reviewSortVal,
        review_prodid: reviewSortProdId
      });
    }
  }

  onAccountRoute(event: CustomEvent) {
    const eventName = 'accountroute';
    const accountRouteVal = event?.detail?.route || '';
    if (accountRouteVal) {
      eventRegistry[eventName]?.(eventName, {
        account_route: accountRouteVal
      });
    }
  }

  onSignIn(event: CustomEvent) {
    const eventName = 'signin';
    const accountReferrer = event?.detail?.provider || '';
    const accountRememberMe = event?.detail?.rememberMe || '';
    const accountSource = event?.detail?.source || '';
    const userId = event?.detail?.userId || '';
    eventRegistry[eventName]?.(eventName, {
      account_referrer: accountReferrer,
      account_rememberme: accountRememberMe,
      account_source: accountSource,
      USER_ID: userId
    });
  }

  onSignInFailed(event: CustomEvent) {
    const eventName = 'signinFailed';
    eventRegistry[eventName]?.(eventName, {
      account_referrer: event?.detail?.provider || '',
      account_source: event?.detail?.source || '',
      account_type: event?.detail?.type || ''
    });
  }

  onOffer(eventName: string, event: CustomEvent) {
    const offerCode = event?.detail || '';
    if (offerCode) {
      eventRegistry[eventName]?.(eventName, {
        offer_code: ['offer code' + ' - ' + offerCode]
      });
    }
  }

  onSampleAdded(event: CustomEvent) {
    const eventName = 'checkoutSampleAdded';
    const sampleProductName = event?.detail?.prodName || '';
    const sampleProductSku = event?.detail?.prodSku || '';
    if (sampleProductSku && sampleProductName) {
      eventRegistry[eventName]?.(eventName, {
        sample_product_name: sampleProductName,
        sample_product_sku: sampleProductSku
      });
    }
  }

  onSampleRemoved(event: CustomEvent) {
    const eventName = 'checkoutSampleRemoved';
    const sampleProductName = event?.detail?.prodName || '';
    const sampleProductSku = event?.detail?.prodSku || '';
    if (sampleProductSku && sampleProductName) {
      eventRegistry[eventName]?.(eventName, {
        cart_sample: [sampleProductName + ' - SKU' + sampleProductSku]
      });
    }
  }

  onRemoveFromCart(event: CustomEvent) {
    const eventName = 'removeFromCart';
    const productSku = event?.detail?.product_sku || '';
    if (productSku) {
      eventRegistry[eventName]?.(eventName, {
        product_sku: [`SKU${productSku}`],
        is_pincer_cart: true
      });
    }
  }

  onAddToCart(event: CustomEvent) {
    const eventName = 'addToCart';
    const productSku = event?.detail?.product_sku || '';
    const productCode = event?.detail?.skuId || '';
    const quantity = event?.detail?.quantity || 0;
    const html = event?.detail?.html || '';
    if (productSku) {
      eventRegistry[eventName]?.(eventName, {
        product_sku: [`SKU${productSku}`],
        is_pincer_cart: true
      });
    } else if (productCode && html) {
      eventRegistry[eventName]?.(eventName, {
        // this is a data layer specific naming convention
        product_product_code: [productCode],
        product_quantity: [quantity],
        is_bf_cart: true
      });
    }
  }

  onCartDrawer(event: CustomEvent) {
    const eventName = 'cartDrawer';
    const drawerItemCategory = event?.detail?.cartDrawerCategory || '';
    const drawerItemAction = event?.detail?.cartDrawerAction || '';
    const drawerItemCta = event?.detail?.cartDrawerCta || '';
    if (drawerItemCta) {
      eventRegistry[eventName]?.(eventName, {
        cartDrawerName: drawerItemCategory,
        cartDrawerCategory: drawerItemCategory,
        cartDrawerAction: drawerItemAction,
        cartDrawerCta: drawerItemCta
      });
    }
  }

  onAltImageClick(event: CustomEvent) {
    const eventName = 'altImage';
    const altImageClickedAction = event?.detail?.altImageAction || '';
    if (altImageClickedAction) {
      eventRegistry[eventName]?.(eventName, {
        altImageAction: altImageClickedAction,
        altImagePosition: event?.detail?.altImagePosition
      });
    }
  }

  onPdpAccordion(event: CustomEvent) {
    const eventName = 'pdpAccordion';
    const productCardHeader = event?.detail?.productCardLabel || '';
    const productCardType = event?.detail?.productCardAction ? 'expand' : 'collapse';
    if (productCardHeader) {
      eventRegistry[eventName]?.(eventName, {
        eventAction: productCardType,
        eventLabel: productCardHeader
      });
    }
  }

  onGnavPromoClick(event: CustomEvent) {
    const eventName = 'navigationClick';
    const promoName = event?.detail?.payload || '';
    if (promoName) {
      eventRegistry[eventName]?.(eventName, promoName);
    }
  }

  onFilterComplete(event: CustomEvent) {
    const eventName = 'filterComplete';
    eventRegistry[eventName]?.(eventName, {
      payload: event.detail.payload
    });
  }

  onCategoryToggle(event: CustomEvent) {
    const eventName = 'categoryToggle';
    const categoryElement = (event.target as HTMLElement).nextElementSibling as HTMLElement;
    const status = categoryElement?.style.display == 'block' ? 'collapse' : 'expand';

    eventRegistry[eventName]?.(eventName, {
      payload: {
        category: event.detail.payload.category,
        status
      }
    });
  }
}
